export function isNullOrWhitespace(text: string): boolean {
    return !text || !text.trim();
}
export function isNullOrUndefinedOrEmpty<T>(items?: T[]): boolean {
    return items === null || items === undefined || items?.length === 0;
}
export function isNullOrUndefined(a?: any): boolean {
    return a === null || a === undefined;
}
export function htmlEscape(text: string) {
    return text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function addHyphenBetweenLowerAndUpper(text: string) {
    return text.replace(/([a-z])([A-Z])/g, "$1-$2");
}

export function getSign(isNegative: boolean): string {
    return isNegative ? "-" : "";
}

export function defaultToEmptyIfNullOrWhitespace(text: string): string {
    return `${isNullOrWhitespace(text) || text.toUpperCase() == "NULL" ? "" : `${text}`}`;
}

export function highlightSearchedValue(text: string, regex: RegExp): string {
    return (text as any).replaceAll(regex, (oldValue: any) => `<b>${oldValue}</b>`);
}
